import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ConfirmDialog from "../../components/Dialogs/ConfirmDialog";
import axios from 'axios';
//import { useNavigate } from "react-router-dom";
import {
    getCompanyId,
    getToken,
    getUser
} from '../../Utils/Common';
//import { clearPersistentStorage } from "../../Utils/usePersistentStorage";
//import { closeSocket } from "../../components/Main/Main";
// import sharePermission from "../../Utils/sharePermission";
//import { usePermissionContext } from "../../contexts/permission-context";
import './UserPermissionsDialog.scss';

const UserPermissionsDialog = ({ open, onClose, userData, onSave, setNotify, setReload }) => {

    // const { setPermissions } = usePermissionContext();

    const [assignType, setAssignType] = useState('OVERRIDE'); // default - OVERRIDE

    const [assetsSelected, setAssetsSelected] = useState([]);

    const [usersSelected, setUsersSelected] = useState([]);

    const [platformSelected, setPlatformSelected] = useState([]);

    const [companySelected, setCompanySelected] = useState([]);

    const [companyDisabled, setCompanyDisabled] = useState([]);

    const [usersDisabled, setUsersDisabled] = useState([]);

    const [platformDisabled, setPlatformDisabled] = useState([]);

    const [assetsDisabled, setAssetsDisabled] = useState([]);

    const allSelectedOptions = [...assetsSelected, ...usersSelected, ...platformSelected, ...companySelected];

    const viewTypeOptions = ['assets.view', 'users.view', 'platform.view', 'company.view'];
    
    const useTypeOptions = ['assets.use', 'users.use', 'platform.use', 'company.use'];
    
    const manageTypeOptions = ['assets.manage', 'users.manage', 'platform.manage', 'company.manage'];
   
    const assetsPermissionOptions = ['assets.view', 'assets.use', 'assets.manage'];
    const usersPermissionOptions = ['users.view', 'users.use', 'users.manage'];
    const platformPermissionOptions = ['platform.view', 'platform.use', 'platform.manage'];
    const companyPermissionOptions = ['company.view', 'company.use', 'company.manage'];

    const permissionTypesOptions = ['Assets', 'Users', 'Platform', 'Company'];

    const saveButtonText = 'Save';
    const cancelButtonText = 'Cancel';
    const title = `Change Permissions for User ${userData.userId}`;

    // const [message, setMessage] = useState(sharePermission.initialState);

    const [confirmOpen, setConfirmOpen] = useState(false);

    const [confirmProps, setConfirmProps] = useState({});
    
    const handleConfirmClose = () => {
      setConfirmOpen(false);
    };

    //const navigate = useNavigate();

    useEffect(() => {
        if (userData && userData.userAuthInfo) {
            let acls = userData?.userAuthInfo?.acls;
            if (acls) {
                let companyPermissionList = [];
                let assetsPermissionList = [];
                let usersPermissionList = [];
                let platformPermissionList = [];

                acls.forEach((acl) => {
                    let rootPermissionType = acl.permission.split('.')[0];

                    if (rootPermissionType === 'assets') {
                        assetsPermissionList.push(acl.permission);
                    } else if (rootPermissionType === 'users') {
                       usersPermissionList.push(acl.permission);
                    } else if (rootPermissionType === 'platform') {
                        platformPermissionList.push(acl.permission);
                    } else if (rootPermissionType === 'company') {
                        companyPermissionList.push(acl.permission);
                    } else {
                        console.log("Unknown permission type: ", acl.permission);
                    }
                });

                setAssetsSelected(assetsPermissionList);
                setUsersSelected(usersPermissionList);
                setPlatformSelected(platformPermissionList);
                setCompanySelected(companyPermissionList);
                setAssetsDisabled(assetsPermissionList);
                setUsersDisabled(usersPermissionList);
                setPlatformDisabled(platformPermissionList);
                setCompanyDisabled(companyPermissionList);
            }
        }
    }, [userData]);

    const handleSave = () => {

        // PUT Request URL: https://cdvdata-d1-c1.dit01-insight-csp.com/monitor/api/companies/0/users/john.doe@test.com/acls?action=ASSIGN
        
        let companyId = userData.companyId;
        let userId = userData.userId;

        let updateAclUrl = `api/companies/${companyId}/users/${userId}/acls?action=${assignType}`;

        // [{"permission":"assets.view","object":"*","objectType":"default"},{"permission":"users.view","object":"*","objectType":"default"},{"permission":"platform.view","object":"*","objectType":"default"},{"permission":"company.view","object":"*","objectType":"company"}]

        let payload = [];

        allSelectedOptions.forEach((acl) => {
            return payload.push({
                permission: acl,
                object: '*',
                objectType: acl.startsWith("company") ? "company" : "default"
            });
        });

        //console.log("payload: ", payload);

        axios({
            method: "put",
            url: updateAclUrl,
            data: payload,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        })
            .then(response => {
                //sharePermission.sendMessage(JSON.stringify(response.data.acls));
               // sessionStorage.setItem("acls", JSON.stringify(response.data.acls));
                let message = `Updated User Permissions [User Name: ${userId}]`;

                setNotify({
                    isOpen: true,
                    message: message,
                    severity: 'info'
                });

                //setApiData([]);
                // only reload if not current user since user is logged out anyways. No need to reload
                if (userId !== getUser()) {
                    setReload(true);
                }

                onSave();
                
               //handleLogout();

            }).catch(error => {
                console.log('error in update user permissions api call:', error);

                let message = `Failed to update user permissions [${userId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });
            });

    };

    const handleClose = (event, reason) => {
        if (reason && reason === "backdropClick") {
            return;
        }
        onClose();
    };

    const handleAssignTypeChange = (event) => {
        let assignType = event.target.value;

        setAssignType(assignType);
    };


    const handleAssetsChange = (permissionType, checkboxValue) => {
        if (permissionType === 'assets.all'|| permissionType === 'assets.manage') {
            if (checkboxValue) {
                setAssetsSelected(assetsPermissionOptions);
                setAssetsDisabled(assetsPermissionOptions)
            } else {
                if (permissionType === 'assets.all') {
                    setAssetsSelected([]);
                    setAssetsDisabled([]);
                }
                if (permissionType === 'assets.manage') {
                    const assetsViewPermissionOptions = ['assets.view', 'assets.use'];
                    setAssetsSelected(assetsViewPermissionOptions);
                    setAssetsDisabled(['assets.view']);
                }
            }
            return;
        }

        if(permissionType === 'assets.use') {
            if(checkboxValue) {
                const assetsViewPermissionOptions = ['assets.view', 'assets.use'];
                setAssetsSelected(assetsViewPermissionOptions);
                setAssetsDisabled(['assets.view']);
            } else {
                setAssetsSelected(['assets.view']);
                setAssetsDisabled([]);
            }
            return;
        }

        const list = [...assetsSelected];
        const index = list.indexOf(permissionType);
        if (checkboxValue) {
            // if permission does not already exist, then add it
            if (index === -1) {
                list.push(permissionType);
            }
        } else {
            // if permission was already selected , then remove it
            if (index !== -1) {
                list.splice(index, 1);
            }
        }
        setAssetsSelected(list);
        setAssetsDisabled(list);
    };

    const handleUsersChange = (permissionType, checkboxValue) => {
        if (permissionType === 'users.all' || permissionType === 'users.manage') {
            if (checkboxValue) {
                setUsersSelected(usersPermissionOptions);
                setUsersDisabled(usersPermissionOptions);
            } else {
                if (permissionType === 'users.all') {
                    setUsersSelected([]);
                    setUsersDisabled([]);
                }
                if (permissionType === 'users.manage') {
                    const usersViewPermissionOptions = ['users.view', 'users.use'];
                    setUsersSelected(usersViewPermissionOptions);
                    setUsersDisabled(['users.view']);
                }
                return;
            }
            return;
        }

        if(permissionType === 'users.use') {
            if(checkboxValue) {
                const usersViewPermissionOptions = ['users.view', 'users.use'];
                setUsersSelected(usersViewPermissionOptions);
                setUsersDisabled(['users.view']);
            } else {
                setUsersSelected(['users.view']);
                setUsersDisabled([]);
            }
            return;
        }

        const list = [...usersSelected];
        const index = list.indexOf(permissionType);
        if (checkboxValue) {
            // if permission does not already exist, then add it
            if (index === -1) {
                list.push(permissionType);
            }
        } else {
            // if permission was already selected , then remove it
            if (index !== -1) {
                list.splice(index, 1);
            }
        }
        setUsersSelected(list);
        setUsersDisabled(list);
    };

    const handlePlatformChange = (permissionType, checkboxValue) => {
        if (permissionType === 'platform.all' || permissionType === 'platform.manage') {
            if (checkboxValue) {
                setPlatformSelected(platformPermissionOptions);
                setPlatformDisabled(platformPermissionOptions);
            } else {
                if (permissionType === 'platform.all') {
                    setPlatformSelected([]);
                    setPlatformDisabled([]);
                }
                if (permissionType === 'platform.manage') {
                    const platformViewPermissionOptions = ['platform.view', 'platform.use'];
                    setPlatformSelected(platformViewPermissionOptions);
                    setPlatformDisabled(['platform.view']);
                }
            }
            return;
        }
        if(permissionType === 'platform.use') {
            if(checkboxValue) {
                const platformViewPermissionOptions = ['platform.view', 'platform.use'];
                setPlatformSelected(platformViewPermissionOptions);
                setPlatformDisabled(['platform.view']);
            } else {
                setPlatformSelected(['platform.view']);
                setPlatformDisabled([]);
            }
            return;
        }
        const list = [...platformSelected];
        const index = list.indexOf(permissionType);
        if (checkboxValue) {
            // if permission does not already exist, then add it
            if (index === -1) {
                list.push(permissionType);
            }
        } else {
            // if permission was already selected , then remove it
            if (index !== -1) {
                list.splice(index, 1);
            }
        }
        setPlatformSelected(list);
        setPlatformDisabled(list);
    };

    const handleCompanyChange = (permissionType, checkboxValue) => {

        if (permissionType === 'company.all' || permissionType === 'company.manage') {
            if (checkboxValue) {
                setCompanySelected(companyPermissionOptions);
                setCompanyDisabled(companyPermissionOptions);
            } else {
                if (permissionType === 'company.all') {
                    setCompanySelected([]);
                    setCompanyDisabled([]);
                }
                if (permissionType === 'company.manage') {
                    const companyViewPermissionOptions = ['company.view', 'company.use'];
                    setCompanySelected(companyViewPermissionOptions);
                    setCompanyDisabled(['company.view']);
                }
            }
            return;
        }

        if(permissionType === 'company.use') {
            if(checkboxValue) {
                const companyViewPermissionOptions = ['company.view', 'company.use'];
                setCompanySelected(companyViewPermissionOptions);
                setCompanyDisabled(['company.view']);
            } else {
                setCompanySelected(['company.view']);
                setCompanyDisabled([]);
            }
            return;
        }

        const list = [...companySelected];
        const index = list.indexOf(permissionType);
        if (checkboxValue) {
            // if permission does not already exist, then add it
            if (index === -1) {
                list.push(permissionType);
            }
        } else {
            // if permission was already selected , then remove it
            if (index !== -1) {
                list.splice(index, 1);
            }
        }
        setCompanySelected(list);
        setCompanyDisabled(list);
    };

    

    const handleSelectAll = (permissionType, checkboxChecked) => {

        if (permissionType === "all.all") {
            if (checkboxChecked) {
                setAssetsSelected(assetsPermissionOptions);
                setUsersSelected(usersPermissionOptions);
                setPlatformSelected(platformPermissionOptions);
                setCompanySelected(companyPermissionOptions);
                setAssetsDisabled(assetsPermissionOptions);
                setUsersDisabled(usersPermissionOptions);
                setPlatformDisabled(platformPermissionOptions);
                setCompanyDisabled(companyPermissionOptions);

            } else {
                setAssetsSelected([]);
                setUsersSelected([]);
                setPlatformSelected([]);
                setCompanySelected([]);
                setAssetsDisabled([]);
                setUsersDisabled([]);
                setPlatformDisabled([]);
                setCompanyDisabled([]);
            }
        }
    };

    const permissionTypeMapping = {
        'all': handleSelectAll,
        'assets': handleAssetsChange,
        'users': handleUsersChange,
        'platform': handlePlatformChange,
        'company': handleCompanyChange
    };

    const updatePermissionsByOperationType = (operationTypeOptions, checkedStatus) => {

        operationTypeOptions.forEach((permissionType) => {

            let rootPermissionType = permissionType.split('.')[0];

            let handler = permissionTypeMapping[rootPermissionType];

            if (handler) {
                handler(permissionType, checkedStatus);
            } else {
                console.log("No handler found for unknown permission type: ", rootPermissionType, permissionType);
            }

        });
    };

    const handleHeaderOperationChange = (event) => {
        let opType = event.target.value;
        let checkedStatus = event.target.checked;
       
        if (opType === 'view.All') { 
            updatePermissionsByOperationType(viewTypeOptions, checkedStatus);
            // if view.all has been cleared, then clear all the disabled states to allow user to change
            if (!checkedStatus) {
                setAssetsDisabled([]);
                setCompanyDisabled([]);
                setUsersDisabled([]);
                setPlatformDisabled([]);
            }
        } else if (opType === 'use.All') {
            updatePermissionsByOperationType(useTypeOptions, checkedStatus);
        } else if (opType === 'manage.All') {
            updatePermissionsByOperationType(manageTypeOptions, checkedStatus);
        } else {
            console.log("Unknown operation type: ", opType);
        }
    };

    const handleTypeChange = (event) => {
        let selectedPermisionType = event.target.value;
        let checkboxChecked = event.target.checked;

        let permissionType = selectedPermisionType.split('.')[0].toLowerCase();

        let handler = permissionTypeMapping[permissionType];

        handler(selectedPermisionType, checkboxChecked);

    };

    const areAllViewTypesSelected = () => {
        let viewOptionsSelected = viewTypeOptions.map((permissionType) => {
            return assetsSelected.includes(permissionType) ||
                usersSelected.includes(permissionType) ||
                platformSelected.includes(permissionType) ||
                companySelected.includes(permissionType);
        });

        return viewOptionsSelected.every(element => element === true);
    };

    const areAllUseTypesSelected = () => {
    
        let useOptionsSelected = useTypeOptions.map((permissionType) => {
            return assetsSelected.includes(permissionType) ||
                usersSelected.includes(permissionType) ||
                platformSelected.includes(permissionType) ||
                companySelected.includes(permissionType);
        });

        return useOptionsSelected.every(element => element === true);
    };

    const areAllManageTypesSelected = () => {

        let manageOptionsSelected = manageTypeOptions.map((permissionType) => {
            return assetsSelected.includes(permissionType) ||
                usersSelected.includes(permissionType) ||
                platformSelected.includes(permissionType) ||
                companySelected.includes(permissionType);
        });

        return manageOptionsSelected.every(element => element === true);
    };

    const areAllPermisionTypesSelected = (permissionType) => {
        if (permissionType === "All") {
            return ((assetsPermissionOptions.length === assetsSelected.length &&
                usersPermissionOptions.length === usersSelected.length &&
                platformPermissionOptions.length === platformSelected.length &&
                companyPermissionOptions.length === companySelected.length));
        } else if (permissionType === "Assets") {
            return assetsPermissionOptions.length === assetsSelected.length;
        } else if (permissionType === "Users") {
            return usersPermissionOptions.length === usersSelected.length;
        } else if (permissionType === "Platform") {
            return platformPermissionOptions.length === platformSelected.length;
        } else if (permissionType === "Company") {
            return companyPermissionOptions.length === companySelected.length;
        } else {
            console.log("Unknown permission type: ", permissionType);
        }

        return false;
    };

    const updateUserPermission = () => {
        // console.log("update User Permission");
        let title = "Update User Permission";
        let confirmButtonText = "Yes";
        let cancelButtonText = "No";
        let msg = `The user ${userData.userId} will be logged out upon changing the permissions. Are you sure?`;
    
        let confirmProps = {
          title,
          msg,
          confirmButtonText,
          cancelButtonText,
          confirmCallback: () => handleSave()
        };
    
        setConfirmProps(confirmProps);
    
        setConfirmOpen(true);
      };

    
    // handle click event of logout button
    /*
    const handleLogout = async (props) => {
        closeSocket();
        // clear all keys set in localstorage

        setTimeout(() => {
        clearPersistentStorage();
        window.sessionStorage.clear();
        navigate('/');
        }, 3000);
    };
    */

    return (
        <Dialog onClose={handleClose} open={open} maxWidth={'md'} fullWidth={true}>
            <DialogTitle>
                <div className="userPermissionDialogTitle">{title}</div>
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
            <DialogContent dividers={true}>
                <div className="assignTypeContainer">
                    <div className="assignTypeRow">
                        <div className="assignType1">
                            <div className="assignTypeLabel">
                                Assign Type
                            </div>
                            <RadioGroup
                                aria-label="Assign Type"
                                name="assignType"
                                value={assignType}
                                onChange={handleAssignTypeChange}
                                row={true}
                            >
                                <FormControlLabel value="ASSIGN" control={<Radio size="small" />} label="Assign" />
                                <FormControlLabel value="UNASSIGN" control={<Radio size="small" />} label="Unassign" />
                                <FormControlLabel value="OVERRIDE" control={<Radio size="small" />} label="Override" />
                            </RadioGroup>
                        </div>

                    </div>
                </div>

                <div className="checkboxSection">

                    <div className="permissionTable">
                        <div className="columnL">


                            <div className="headerCell">
                                <FormControlLabel
                                    control={
                                        <Checkbox value="all.all" checked={areAllPermisionTypesSelected('All')} size="small" onClick={handleTypeChange} />
                                    } label='All' />

                            </div>

                            {permissionTypesOptions.map((permissionType) => {
                                return (
                                    <div className="headerCell">
                                        <FormControlLabel
                                            control={
                                                <Checkbox value={`${permissionType.toLowerCase()}.all`} checked={areAllPermisionTypesSelected(permissionType)} size="small" onClick={handleTypeChange} />
                                            } label={permissionType} />

                                    </div>
                                );
                            })}
                        </div>

                        <div className="column">

                            <div className="headerCell2">
                                <FormControlLabel
                                    control={
                                        <Checkbox value="view.All" checked={areAllViewTypesSelected()} size="small" onClick={handleHeaderOperationChange} />
                                    } label="View" />
                            </div>


                            {
                                viewTypeOptions.map((viewType) => {
                                    return (
                                        <div className="dataCell">
                                            <FormControlLabel
                                                control={
                                                    <Checkbox value={viewType}
                                                    name={viewType}
                                                    disabled={
                                                            companyDisabled.includes(viewType) ||
                                                            platformDisabled.includes(viewType) ||
                                                            usersDisabled.includes(viewType) ||
                                                            assetsDisabled.includes(viewType)
                                                    }
                                                        checked={
                                                            companySelected.includes(viewType) ||
                                                            usersSelected.includes(viewType) ||
                                                            assetsSelected.includes(viewType) ||
                                                            platformSelected.includes(viewType)}
                                                        size="small"
                                                        onChange={handleTypeChange} />
                                                } label={viewType} />
                                        </div>
                                    );
                                })
                            }

                        </div>

                        <div className="column">

                            <div className="headerCell2">

                                <FormControlLabel
                                    control={
                                        <Checkbox value="use.All" checked={areAllUseTypesSelected()} size="small" onClick={handleHeaderOperationChange} />
                                    } label="Use" />
                            </div>

                            {
                                useTypeOptions.map((useType) => {
                                    return (
                                        <div className="dataCell">
                                            <FormControlLabel
                                                control={
                                                    <Checkbox value={useType}
                                                    name={useType}
                                                    disabled={
                                                        companyDisabled.includes(useType) ||
                                                        platformDisabled.includes(useType) || 
                                                        usersDisabled.includes(useType) ||
                                                        assetsDisabled.includes(useType)
                                                    }
                                                    checked={
                                                        companySelected.includes(useType) ||
                                                        usersSelected.includes(useType) ||
                                                        assetsSelected.includes(useType) ||
                                                        platformSelected.includes(useType)} size="small" onChange={handleTypeChange} />
                                                } label={useType} />
                                        </div>
                                    );
                                })
                            }
                        </div>

                        <div className="column">

                            <div className="headerCell2">

                                <FormControlLabel
                                    control={
                                        <Checkbox value="manage.All" checked={areAllManageTypesSelected()} size="small" onClick={handleHeaderOperationChange} />
                                    } label="Manage" />
                            </div>

                            {
                                manageTypeOptions.map((manageType) => {
                                    return (
                                        <div className="dataCell">
                                            <FormControlLabel
                                                control={
                                                    <Checkbox value={manageType} 
                                                    name={manageType}
                                                   
                                                    checked={
                                                        companySelected.includes(manageType) ||
                                                        usersSelected.includes(manageType) ||
                                                        assetsSelected.includes(manageType) ||
                                                        platformSelected.includes(manageType)} onChange={handleTypeChange} size="small" />
                                                } label={manageType} />
                                        </div>
                                    );
                                })
                            }
                        </div>


                    </div>
                </div>


            </DialogContent>

            <DialogActions>
                <Button variant="text" size="small" sx={{ textTransform: 'none' }} onClick={handleClose}>{cancelButtonText}</Button>
                <Button
                    variant="contained"
                    size="small"
                    sx={{
                        color: '#333330',
                        backgroundColor: '#82C027',
                        boxShadow: '0px 1px 2px #6F7687',
                        borderRadius: '5px',
                        textTransform: 'none',
                        '&:hover': {
                            backgroundColor: '#82C027',
                            boxShadow: 'none'
                        }
                    }}
                    onClick={updateUserPermission}>{saveButtonText}</Button>
            </DialogActions>

            <ConfirmDialog
            title={confirmProps.title}
            open={confirmOpen}
            onClose={handleConfirmClose}
            setOpen={setConfirmOpen}
            cancelButtonText={confirmProps.cancelButtonText}
            confirmButtonText={confirmProps.confirmButtonText}
            onConfirm={confirmProps.confirmCallback}
            >
            {confirmProps.msg}
            </ConfirmDialog>
        </Dialog >

    );
}


export default UserPermissionsDialog;